import MiniProgramPage from 'C:/Users/elkers/Desktop/firm/dev/szwl-wx-test/pages/login/index.vue'
wx.createPage(MiniProgramPage)